module.exports = __webpack_public_path__ + "static/media/header-logo.c3e22630.png";